import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const SBCaaSTrunkTypesField = ({ options, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{
                    ...stackStyling(true),
                    height: 'auto',
                    minHeight: '75px',
                }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Trunk Types <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select one or more trunk types for this SBCaaS profile.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                name="trunkTypes"
                                validate={(value) =>
                                    (!value || value.length === 0) &&
                                    'Please select at least one trunk type'
                                }>
                                {({ field, form, meta }) => (
                                    <>
                                        <DropDown
                                            name="trunkTypes"
                                            isMulti
                                            data={options}
                                            shownValue="name"
                                            multiValue={
                                                Array.isArray(field.value)
                                                    ? field.value.map(
                                                          (item) => item.id,
                                                      )
                                                    : []
                                            }
                                            walkthroughId={
                                                walkthroughIds.serviceProfiles
                                                    ?.ufTrunkTypesSelect
                                            }
                                            placeholder="- Select Trunk Types -"
                                            darkMode={darkMode}
                                            width="100%"
                                            noPadding
                                            handleSelectChange={(ids) => {
                                                const selected = (ids || [])
                                                    .map((id) =>
                                                        (options || []).find(
                                                            (option) =>
                                                                option.id ===
                                                                id,
                                                        ),
                                                    )
                                                    .filter(Boolean);
                                                form.setFieldValue(
                                                    'trunkTypes',
                                                    selected,
                                                );
                                            }}
                                        />
                                        {meta.touched && meta.error && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                                textAlign="right">
                                                {meta.error}
                                            </Text>
                                        )}
                                    </>
                                )}
                            </Field>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select one or more trunk types."
                        ariaLabel="sbcaas-trunk-types-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SBCaaSTrunkTypesField;
